import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cd9ccd52&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cd9ccd52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9ccd52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd9ccd52')) {
      api.createRecord('cd9ccd52', component.options)
    } else {
      api.reload('cd9ccd52', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cd9ccd52&scoped=true", function () {
      api.rerender('cd9ccd52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/oa/components/FileCell/index.vue"
export default component.exports